module.exports = __webpack_public_path__ + "static/logo-zh_-1bfb00a9d9d95cb8cf443269ededc400.png";